import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { TextField, Toolbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import { useState, useEffect } from "react";
import axios from "axios";
// // import CheckCircleIcon from "lucide-react";
// import { styled } from "@mui/material/styles";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "30px",
};

const AddSpecialModal = () => {
  const [open, setOpen] = useState(false); // Modal open state
  const [eventname, setEventName] = useState("");
  const [description, setDescription] = useState("");
  const [isSpecial, setIsSpecial] = useState(false);
  const [id, setId] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar state

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (id) {
      axios
        .get(`https://tsetsegtuw.templateapi.xyz/event/${id}`)
        .then((response) => {
          console.log("Event fetched successfully:", response.data.data);
          setEventName(response.data.data.eventName);
          setDescription(response.data.data.description);
          setIsSpecial(response.data.data.isSpecial);
        })
        .catch((error) => {
          console.error("Error fetching event data:", error);
        });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const eventData = {
      eventName: eventname,
      description,

      isSpecial,
    };

    try {
      const response = await axios.post(
        "https://tsetsegtuw.templateapi.xyz/event",
        eventData
      );
      console.log("Event saved successfully:", response.data.data);
      setSnackbarOpen(true);
      setOpen(false);
      setTimeout(() => {
        window.location.reload(false);
      }, 1000);
    } catch (error) {
      console.error("Error saving event:", error);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  return (
    <Toolbar>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Тэмдэглэлт өдөр нэмэх
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <DialogTitle
            sx={{
              color: (theme) =>
                theme.palette.mode === "dark" ? "white" : "black",
            }}
          >
            Тэмдэглэлт өдөр нэмэх
            <IconButton onClick={handleClose} style={{ float: "right" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} margin={2}>
              <TextField
                variant="outlined"
                label="Нэр"
                value={eventname}
                onChange={(e) => setEventName(e.target.value)}
              />
              <TextField
                variant="outlined"
                label="Албан тушаал"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Хадгалах
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Хаах
                </Button>
              </Box>
            </Stack>
          </DialogContent>
        </Box>
      </Modal>
      <Snackbar
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={
          <span className="flex items-center text-green-500">
            Амжилттай бүртгэлээ
          </span>
        }
      />
    </Toolbar>
  );
};

export default AddSpecialModal;
